import { uniq } from "lodash";
import _this from '@/main'
import { baseBPM, baseNonSale } from '@/assets/js/base-url.js';
import http from '@/assets/js/http';
import util from "@/util/util.js";
import { Message } from 'element-ui';


export default {
    // Change Input 单元格样式
    cellClassName(val) {
        let object = {
            "000": "change-remove",
            "001": "change-initiated",
            "002": "change-waiting-for-change-input",
            "003": "change-cancelled",
            "030": "change-cancelled-launch",
            "004": "change-returned",
            "005": "change-submitted",
            "006": "change-validated",
            "008": "change-waiting-for-approval",
            "009": "change-approved",
            "360": "change-SAP-upload-completed",
            "010": "change-ready-to-publish",
            "200": "change-publish",
            "300": "cell_pending",
            "040": "change-rejected",
            "050": "change-released",
            "056": "change-cancelled",
            "057": "cell_light_green",
            "055": "cell_reject",
            "058": "cell_pending",
            "059": "cell_approval",
            "060": "change-cancelled",
        };
        let returnVal = val
        for (const key in object) {
            if (key === val) {
                returnVal = object[key];
            }
        }
        return returnVal;
    },
    unwrapFieldVal(field) {
        if (field && typeof field === "object" && Object.prototype.hasOwnProperty.call(field, "value")) {
            return field.value;
        }
        return field;
    },
    // RBU Approver 仅在 changeType 含 Price 且 Need RBU Approval=Y 时需要审批，其余置灰
    isRbuApproverRequired(fieldVal) {
        if (!fieldVal) {
            return false;
        }
        const changeType = this.unwrapFieldVal(fieldVal.change_type) || "";
        const needRbuApproval = this.unwrapFieldVal(fieldVal.need_rbu_approval);
        const hasPrice = String(changeType).split(",").map(item => item.trim()).includes("Price");
        return hasPrice && needRbuApproval === "Y";
    },
    // FPC 状态匹配
    ChangeStatus(val) {
        let object = {
            "Change Draft": "change-draft",
            "Waiting For Change Input": "change-waiting-for-change-input",
            "Change Initiated": "change-initiated",
            "Cancelled Launch": "change-cancelled",
            "Change Returned": "change-returned",
            "Change Submitted": "change-submitted",
            "Change Validated": "change-validated",
            "Change Waiting for Approval": "change-waiting-for-approval",
            "Change Approved": "change-approved",
            "SAP Upload completed": "change-SAP-upload-completed",
            "Change Ready to Publish": "change-ready-to-publish",
            "Change Published": "change-published",
            "Change Rejected": "change-rejected",
            "Change Released": "change-released",
            "Remove": "cell_gray",
            "Draft": "cell_light_yellow",
            "Waiting for Data Input": "cell_white",
            "Cancelled": "cell_gray",
            "Returned": "cell_red",
            "Submitted": "cell_light_green",
            "Validated": "cell_dark_green",
            "Seek for Approval": "cell_light_blue",
            "Approved": "cell_approval",
            "Ready to Publish": "cell_ready-to-publish",
            "Rejected": "cell_reject",
            "Published": "cell_blue",
            "Pending": "cell_pending",
            "Completed": "cell_blue",
            "System Rejected": "system-reject",
            "Waiting for Brand Input": "waiting-for-brand-input",
            "Waiting for Corporate Validation": "waiting-for-corporate-validation",
            "Withdraw": "change-rejected",
        };
        let returnVal = val
        for (const key in object) {
            if (key === val) {
                returnVal = object[key];
            }
        }
        return returnVal;
    },
    // basePrice 状态颜色匹配
    basePriceStatus(val) {
        let object = {
            "Remove": "change-remove",
            "Draft": "cell_light_yellow",
            "Waiting for Data Input": "change-waiting-for-change-input",
            "Cancelled": "change-cancelled",
            "Cancelled Launch": "change-cancelled",
            "Returned": "change-returned",
            "Submitted": "change-submitted",
            "Validated": "change-validated",
            "Waiting for Approval": "change-waiting-for-approval",
            "Approved": "change-approved",
            "SAP Upload completed": "change-SAP-upload-completed",
            "Ready to Publish": "change-ready-to-publish",
            "Published": "change-published",
            "Rejected": "change-rejected",
            "Released": "change-released",
            "System Rejected": "system-reject",
            "Waiting for Brand Input": "waiting-for-brand-input",
            "Waiting for Corporate Validation": "waiting-for-corporate-validation",
            "Withdraw": "change-rejected",
        };
        let returnVal = val
        for (const key in object) {
            if (key === val) {
                returnVal = object[key];
            }
        }
        return returnVal;
    },
    // Price List FPC Status 状态匹配
    PriceListFPCStatus(val) {
        let object = {
            "Waiting for Validation": "change-waiting-for-approval",
            "Validated": "change-validated",
            "SAP Upload completed": "change-SAP-upload-completed",
            "Ready to Publish": "change-ready-to-publish",
            "Published": "change-published",
            "Rejected": "Rejected",
            "No need to Publish": "change-cancelled"
        };
        let returnVal = val
        for (const key in object) {
            if (key === val) {
                returnVal = object[key];
            }
        }
        return returnVal;
    },
    // 获取两个数组不同的地方
    getArrDifference(arr1, arr2) {
        return arr1.concat(arr2).filter(function (v, i, arr) {
            return arr.indexOf(v) === arr.lastIndexOf(v);
        });
    },
    // BPM 对 lsr tpr 校验
    checkLsrTpr(name, row, label) {
        let res = false;
        let warnTxt = "";
        if (name === "lsr") {
            if (row.product_nature_1 === "Promotion Pack") {
                if (row.lsr_io_number) {
                    // if(type === 'price') {
                        res = ["", null].includes(row[name].value) || row[name].value > 0;
                        warnTxt = `Invalid input, please input negative number or 0.00`;
                    // } else {
                    //     res = ["", null].includes(row[name].value) || row[name].value >= 0.00;
                    //     warnTxt = `Invalid input, please input negative number`;
                    // }
                } else {
                    res = ["", null].includes(row[name].value) || row[name].value != 0;
                    warnTxt = `Invalid input, please input 0.00`;
                }
            } else if (row.product_nature_1 === "Normal Pack") {
                res = !["", null].includes(row[name].value);
                warnTxt = `Product Nature is a pre-requisite for ${label}. Please request GTM SPOC to input data.`;
            }
        } else if (name === "tpr") {
            if (row.tpr_end_date) {
                if (row.tpr_io_number) {
                    // if(type === 'price') {
                        res = ["", null].includes(row[name].value) || row[name].value > 0;
                        warnTxt = `Invalid input, please input negative number or 0.00`;
                    // } else {
                    //     res = ["", null].includes(row[name].value) || row[name].value >= 0;
                    //     warnTxt = `Invalid input, please input negative number.`;
                    // }
                } else {
                    res = ["", null].includes(row[name].value) || row[name].value != 0;
                    warnTxt = `Invalid input, please input 0.00`;
                }
            } else {
                if (!row.tpr_io_number) {
                    res = !["", null].includes(row[name].value);
                    warnTxt = `TPR IO is pre-requisite for this field, please request your MDS to provide the correct value.`;
                }
            }
        }
        return { res, warnTxt };
    },
    // 数据去重
    uniArr(data, subName, key) {
        let arr = [];
        data.forEach(item => {
            arr.push(item[subName][key]);
        });
        return uniq(arr);
    },
    // 清空后面值，下拉选项
    clearValOpt(name, row, that, natrueArr = ["product_nature_1", "product_nature_2", "product_type_1", "promotion_pack_type", "promotion_pack_detail"]) {
        let idx = natrueArr.findIndex(it => it === name);
        natrueArr.forEach((ele, i) => {
            if (i >= idx) {
                row.field_val[ele].value = "";
                that.nature[row.field_val.basic_id + "," + row.field_val.price_id][ele] = false;
            }
            if (i > idx) {
                row.field_val[ele].options = [];
            }
        });
    },
    // sos data跟当前时间的对比
    currentVsSosdate(sosdate) {
        let sosdateTime = new Date(sosdate).getTime()
        let current = new Date()
        let year = current.getFullYear()
        let month = current.getMonth()<0? '0' + (current.getMonth()+1): current.getMonth()+1
        let day = current.getDate()<0? '0'+current.getDate(): current.getDate()
        let currentTime = new Date(year+"-"+month+"-"+day).getTime()
        return currentTime>sosdateTime
    },
    // System Price Effective Date 跟当前时间的对比
    currentVsSPEdate(SPEdate) {
        let SPEdateTime = new Date(SPEdate).getTime()
        let current = new Date()
        let year = current.getFullYear()
        let month = current.getMonth()<0? '0' + (current.getMonth()+1): current.getMonth()+1
        let day = current.getDate()<0? '0'+current.getDate(): current.getDate()
        let currentTime = new Date(year+"-"+month+"-"+day).getTime()
        return currentTime < SPEdateTime
    },
    // DTC System Price Effective Date 跟当前时间的对比
    dtcCurrentVsSPEdate(SPEdate) {
        let SPEdateTime = new Date(SPEdate).getTime()
        let current = new Date()
        let year = current.getFullYear()
        let month = current.getMonth()<0? '0' + (current.getMonth()+1): current.getMonth()+1
        let day = current.getDate()<0? '0'+current.getDate(): current.getDate()
        let currentTime = new Date(year+"-"+month+"-"+day).getTime()
        return currentTime <= SPEdateTime
    },
    // 校验CDDA数据
    checkDateInCDDA(code) {
        return new Promise((reslove) => {
            http.post(`${baseBPM}/cdda/data-input/cdd_status_msg`, code )
            .then(res => {
                reslove(res.data);
            }).catch(error => {
                reslove(null);
            })
        })
    },
    // 校验 base price 流程相关
    checkDateInBasePrice(params) {
        return new Promise((reslove) => {
            http.post(`${baseNonSale}/base-price/data-validation/publishValidateProductCode`, params )
            .then(res => {
                reslove(res.data);
            }).catch(error => {
                reslove(null);
            })
        })
    },
    // 校验 Join In DSTC 是否可编辑
    checkJoinDSTC(params) {
        return new Promise((reslove) => {
            http.post(`${baseBPM}/bpm/preselling-dstc-config/getConfig`, params)
            .then(res => {
                reslove(res.data);
            }).catch(error => {
                reslove(null);
            })
        })
    },
    downLoadByTaskId(taskId) {
        return new Promise((reslove) => {
            let export_flag = true;
            let times = setInterval(async () => {
                try {
                    // 获取fileID （后端异步）
                    let { data } = await http.get(`${baseBPM}/dms/export/get-task-by-id`, { task_id: taskId });
                    // 成功获取到 fileID
                    if (data.file_id) {
                      if(export_flag){  //防止多次下载
                        export_flag =  false;
                        reslove(true);
                        window.open(util.getFileSignature("", data.file_id))   //新页面导出
                        window.clearInterval(times);
                      }
                    } else if (data.failure_reason) {
                      // 导出有报错
                      reslove(true);
                      Message.error(data.failure_reason);
                      window.clearInterval(times);
                    }
                    
                } catch (error) {
                    console.log(error);
                    
                    reslove(true);
                }
            }, 1000);
        })
    }
}

export const x1MDSfield = [
    "combine_effective_date_from",
    "earliest_conversion_date",
    "lsr_io_number",
    "manufacture_city_name",
    "sap_nro_effective_from_date",
    "tpr_end_date",
    "tpr_io_number"];  // X1 MDS 可编辑字段
export const x1RBUfield = [
    "consumer_discount",
    "customer_discount",
    "lsr",
    "sap_base_price",
    "spp_normal_dm",
    "spp_top_dm",
    "srp",
    "tpr"];  // X1 RBU 可编辑字段
// 页数 梯度
export const pageSizes = [20, 30, 40, 50, 100];
export const pageSize = 50;



// WEBPACK FOOTER //
// ./src/view/BPM/util/util.js